const SIZE_GUIDE_SELECTOR = 'table#size-guide, table[data-fg-size-guide]';

/** @param {Element} cell */
function cleanCellText(cell) {
  return (cell.textContent || '').replace(/\s+/g, ' ').trim();
}

/** @param {string} unit */
function shortUnit(unit) {
  const normalized = unit.toLocaleLowerCase();
  if (normalized === 'inch' || normalized === 'inches' || normalized === 'hüvelyk') return 'in';
  return unit;
}

function sizeLabel() {
  return document.documentElement.lang.toLocaleLowerCase().startsWith('hu') ? 'MÉRET' : 'SIZE';
}

/** @param {HTMLTableElement} table */
function buildMobileSizeGuide(table) {
  if (table.dataset.fgSizeGuide === 'ready') return;

  const rows = Array.from(table.rows);
  if (rows.length < 3) return;

  const sizeCells = Array.from(rows[0].cells).slice(1);
  const unitCells = Array.from(rows[1].cells).slice(1);
  const measurementRows = rows.slice(2).filter((row) => row.cells.length > 1);
  if (!sizeCells.length || !unitCells.length || !measurementRows.length) return;

  const cards = document.createElement('div');
  cards.className = 'fg-size-guide-cards';
  cards.setAttribute('data-fg-size-guide-cards', '');

  let valueOffset = 0;
  sizeCells.forEach((sizeCell) => {
    const span = Math.max(1, sizeCell.colSpan || 1);
    const size = cleanCellText(sizeCell);
    if (!size) {
      valueOffset += span;
      return;
    }

    const card = document.createElement('section');
    card.className = 'fg-size-guide-card';

    const heading = document.createElement('h4');
    heading.className = 'fg-size-guide-card__size';
    heading.textContent = `${sizeLabel()} ${size}`;
    card.appendChild(heading);

    const measurements = document.createElement('dl');
    measurements.className = 'fg-size-guide-card__measurements';

    measurementRows.forEach((row) => {
      const cells = Array.from(row.cells);
      const label = cleanCellText(cells[0]);
      if (!label) return;

      const values = cells.slice(1 + valueOffset, 1 + valueOffset + span);
      const measurement = document.createElement('div');
      measurement.className = 'fg-size-guide-card__measurement';

      const term = document.createElement('dt');
      term.textContent = label;

      const definition = document.createElement('dd');
      values.forEach((cell, index) => {
        const value = cleanCellText(cell);
        if (!value) return;

        const valueLine = document.createElement('span');
        if (index > 0) valueLine.className = 'fg-size-guide-card__secondary';
        const unit = shortUnit(cleanCellText(unitCells[valueOffset + index]));
        valueLine.textContent = unit ? `${value} ${unit}` : value;
        definition.appendChild(valueLine);
      });

      measurement.append(term, definition);
      measurements.appendChild(measurement);
    });

    card.appendChild(measurements);
    cards.appendChild(card);
    valueOffset += span;
  });

  if (!cards.children.length) return;

  table.dataset.fgSizeGuide = 'ready';
  const wrapper = table.parentElement?.classList.contains('rte-table-wrapper') ? table.parentElement : null;
  (wrapper || table).insertAdjacentElement('afterend', cards);
}

/** @param {ParentNode} root */
function enhanceSizeGuides(root = document) {
  if (root instanceof HTMLTableElement && root.matches(SIZE_GUIDE_SELECTOR)) {
    buildMobileSizeGuide(root);
  }
  root.querySelectorAll?.(SIZE_GUIDE_SELECTOR).forEach((table) => {
    if (table instanceof HTMLTableElement) buildMobileSizeGuide(table);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enhanceSizeGuides(), { once: true });
} else {
  enhanceSizeGuides();
}

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) enhanceSizeGuides(node);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
